import { Controller } from "stimulus";

export class DropdownSelectorController extends Controller {
  static targets = ["inputField", "form", "list"];

  connect() {
    document.addEventListener("click", this.#handleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.#handleClickOutside);
  }

  #handleClickOutside = (event) => {
    if (!this.hasListTarget) return;

    const isVisible = this.listTarget.classList.contains("tw-opacity-1");

    if (!isVisible) return;

    if (!this.element.contains(event.target)) {
      this.toggleVisibilty();
    }
  };

  classesToToggle = [
    "tw-opacity-0",
    "tw-pointer-events-none",
    "tw-opacity-1",
    "tw-pointer-events-auto",
  ];

  toggleVisibilty() {
    this.classesToToggle.forEach((className) => {
      this.listTarget.classList.toggle(className);
    });
  }

  submit(event) {
    event.preventDefault();
    const value = event.currentTarget.getAttribute("value");
    this.inputFieldTarget.value = value;
    this.formTarget.submit();
  }
}

Stimulus.register("dropdownSelector", DropdownSelectorController);
